import { Card, Row, Col } from 'antd';
import { useTheme } from 'styled-components';
import { EIconNames, Icon } from 'components/Base/Icon';
import { Paragraph } from 'components/Base/Typography';
import { EAllowedOperation } from 'data/types/notes.types';
import { TNoteItemProps } from '../Notes.types';

const NoteItem = ({ note, onEdit, onDelete }: TNoteItemProps) => {
  const theme = useTheme();

  const canWrite = note.allowedOperation === EAllowedOperation.READ_WRITE;
  const canDelete = note.allowedOperation === EAllowedOperation.READ_WRITE;

  const formattedCreatedDate = note.createdDate
    ? new Date(note.createdDate).toLocaleDateString()
    : '';
  const formattedModifiedDate = note.updatedDate
    ? new Date(note.updatedDate).toLocaleDateString()
    : null;

  return (
    <div style={{ marginBottom: 16 }}>
      <Card
        className="mb-0"
        style={{
          border: note.isPrivate ? '1px solid #0077A0' : undefined,
          padding: 16,
        }}
        bodyStyle={{ padding: 0 }}
      >
        <Row justify="space-between" align="middle" style={{ marginBottom: 0 }}>
          <Col>
            <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
              <Paragraph className="mb-0" style={{ fontSize: 12 }}>
                Entered by:{' '}
                <strong style={{ color: theme.colorBlackPrimary }}>
                  {note.createdByName}
                </strong>{' '}
                on {formattedCreatedDate}
              </Paragraph>
              <span
                style={{
                  fontSize: 12,
                  height: 22,
                  lineHeight: '22px',
                  padding: '0 8px',
                  borderRadius: 4,
                  display: 'inline-block',
                  cursor: 'default',
                  color: note.isPrivate ? '#fff' : undefined,
                  backgroundColor: note.isPrivate ? '#722ed1' : '#f0f0f0',
                  border: note.isPrivate
                    ? '1px solid #722ed1'
                    : '1px solid #d9d9d9',
                }}
              >
                {note.isPrivate ? 'Private' : 'Public'}
              </span>
            </div>
          </Col>
          <Col>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              {canWrite && (
                <div
                  onClick={() => onEdit(note)}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      onEdit(note);
                    }
                  }}
                  role="button"
                  tabIndex={0}
                  style={{ display: 'flex' }}
                  aria-label="Edit note"
                >
                  <Icon
                    icon={EIconNames.EDIT_OUTLINED}
                    color={theme.colorBlackIconColor}
                    className="pointer"
                  />
                </div>
              )}
              {canDelete && (
                <div
                  onClick={() => onDelete(note.resourceId)}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      onDelete(note.resourceId);
                    }
                  }}
                  role="button"
                  tabIndex={0}
                  style={{ display: 'flex' }}
                  aria-label="Delete note"
                >
                  <Icon
                    icon={EIconNames.DELETE_OUTLINED}
                    color={theme.colorBlackIconColor}
                    className="pointer"
                  />
                </div>
              )}
            </div>
          </Col>
        </Row>

        <div
          className="note-content"
          dangerouslySetInnerHTML={{ __html: note.note }}
          style={{
            padding: '8px 0',
            lineHeight: 1.6,
            overflowWrap: 'break-word',
            wordBreak: 'break-word',
            overflow: 'hidden',
          }}
        />

        {formattedModifiedDate && (
          <Paragraph
            className="mb-0"
            style={{
              color: '#8c8c8c',
              fontSize: 12,
              marginTop: 12,
              fontStyle: 'italic',
            }}
          >
            Last modified on {formattedModifiedDate} by {note.updatedByName}
          </Paragraph>
        )}
      </Card>
    </div>
  );
};

export default NoteItem;
